// eslint-disable-next-line
var ajax = $.ajax;
const url_req = "./php/request.php";

function updateAuth() {
  // eslint-disable-next-line
  let auth = BX24.getAuth();

  return {
    domain: auth.domain,
    token: auth.access_token,
  };
}
export function getLangToSaveStage2() {
  // eslint-disable-next-line
  return BX24.getLang();
}

function FetchBody(body) {
  var formData = new FormData();
  let auth = updateAuth();
  formData.append("domain", auth.domain);
  formData.append("auth", auth.token);
  FormDataRecursion(formData, body);
  return formData;
}

function FormDataRecursion(formData, dataVal, dataKey, dataSubKey) {
  if (typeof dataVal != "object") {
    if (dataSubKey != undefined) {
      return formData.append(dataSubKey + "[" + dataKey + "]", dataVal);
    }
    return formData.append(dataKey, dataVal);
  } else {
    for (let [key, value] of Object.entries(dataVal)) {
      FormDataRecursion(formData, value, key, dataKey);
    }
  }
}

export function getLang() {
  return ajax({
    type: "POST",
    url: url_req,
    data: {
      run: "getlang", // eslint-disable-next-line
      lang: BX24.getLang(),
    },
  });
}

export function getLangNEW() {
  // eslint-disable-next-line
  let lang = BX24.getLang();
  return fetch(url_req, {
    method: "POST",
    body: FetchBody({ run: "getlang", lang: lang }),
  });
}

export function getSettings() {
  return fetch(url_req, {
    method: "POST",
    body: FetchBody({
      run: "getsettings",
      part_data: 0,
    }),
  });
}

export function editClose(mainid) {
  return fetch(url_req, {
    method: "POST",
    body: FetchBody({
      run: "editclose",
      mainid: mainid,
    }),
  });
}

export function saveSettings(params) {
  let auth = updateAuth();
  return ajax({
    type: "POST",
    url: url_req,
    data: {
      run: "savesettings",
      words: params.words,
      SPECJALIZACJA: params.SPECJALIZACJA,
      folder: params.folder,
      companyType: params.companyType,
      responsible: params.responsible,
      nip: params.nip,
      nip_field: params.nip_field,
      mail_folder: params.mail_folder,
      mail_user: params.mail_user,
      domain: auth.domain,
      auth: auth.token,
    },
  });
}

export function saveMatrix(matrix) {
  let auth = updateAuth();
  return ajax({
    type: "POST",
    url: url_req,
    data: {
      run: "saveright",
      access_matrix: matrix,
      domain: auth.domain,
      auth: auth.token,
    },
  });
}
export function saveLicense(key) {
  let auth = updateAuth();
  return ajax({
    type: "POST",
    url: url_req,
    data: {
      run: "savelicense",
      licensekey: key,
      domain: auth.domain,
      auth: auth.token,
    },
  });
}

export function saveTableSize(table_size) {
  let auth = updateAuth();
  return ajax({
    type: "POST",
    url: url_req,
    data: {
      run: "savetablesize",
      table_size: table_size,
      domain: auth.domain,
      auth: auth.token,
    },
  });
}

export function Sort(part_data, sortData, filterData) {
  let auth = updateAuth();
  return ajax({
    type: "POST",
    url: url_req,
    data: {
      run: "sort",
      domain: auth.domain,
      auth: auth.token,
      part_data: part_data,
      sort_column: sortData.sort_column,
      sort_order: sortData.sort_order == "ascend" ? "ASC" : "DESC",
      filterParams: filterData,
    },
  });
}

export function getFilter(searchParams) {
  let auth = updateAuth();
  return ajax({
    type: "POST",
    url: url_req,
    data: {
      run: "setfilter",
      domain: auth.domain,
      auth: auth.token,
      params: searchParams,
    },
  });
}

export function getDocumentAllStage(flagFirstStage, fileID) {
  let auth = updateAuth();
  return ajax({
    type: "POST",
    url: url_req,
    data: {
      run: "getdocumentallstage",
      domain: auth.domain,
      auth: auth.token,
      first_stage: flagFirstStage,
      id_file: fileID,
    },
  });
}

export function getHistory(documentID) {
  let auth = updateAuth();
  return ajax({
    type: "POST",
    url: url_req,
    data: {
      run: "gethistory",
      domain: auth.domain,
      auth: auth.token,
      doc_id: documentID,
    },
  });
}

export function requestStep(data) {
  let auth = updateAuth();
  return ajax({
    type: "POST",
    url: url_req,
    data: Object.assign(data, {
      domain: auth.domain,
      auth: auth.token,
    }),
  });
}

export function returnToNew(file_id) {
  let auth = updateAuth();
  return ajax({
    type: "POST",
    url: url_req,
    data: {
      run: "returnToNew",
      id: file_id,
      domain: auth.domain,
      auth: auth.token,
    },
  });
}

export function returnToDescription(file_id) {
  let auth = updateAuth();
  return ajax({
    type: "POST",
    url: url_req,
    data: {
      run: "returnToDescription",
      id: file_id,
      domain: auth.domain,
      auth: auth.token,
    },
  });
}

export function uploadFile(formData) {
  let auth = updateAuth();
  formData.append("domain", auth.domain);
  formData.append("auth", auth.token);

  console.log("formData");
  console.log(formData);

  return ajax({
    type: "POST",
    url: url_req,
    processData: false,
    contentType: false,
    data: formData,
  });
}

export function deletePage(fileID, currentPage) {
  let auth = updateAuth();
  return ajax({
    type: "POST",
    url: url_req,
    data: {
      run: "deletePage",
      fileID,
      currentPage,
      domain: auth.domain,
      auth: auth.token,
    },
  });
}

export function checkNIP(NIP) {
  return ajax({
    type: "POST",
    url: "https://nip.app.support.pl/integration.php",
    data: {
      nip: NIP,
    },
  });
}

export function commentAdd(comments, element) {
  let auth = updateAuth();
  let data = {
    run: "savecomment",
    comments: comments,
    domain: auth.domain,
    auth: auth.token,
  };
  if (element.mainid != undefined) {
    data = Object.assign(data, {
      docID: element.mainid,
      fileID: element.ID,
    });
  } else {
    data = Object.assign(data, element);
  }
  return ajax({
    type: "POST",
    url: url_req,
    data: data,
  });
}

export function getPoglad(file_id) {
  let auth = updateAuth();
  return ajax({
    type: "POST",
    url: url_req,
    data: {
      run: "poglad",
      id: file_id,
      domain: auth.domain,
      auth: auth.token,
    },
  });
}

export function deleteFile(main_id, file_id) {
  let auth = updateAuth();
  return ajax({
    type: "POST",
    url: url_req,
    data: {
      run: "fileDelete",
      mainid: main_id,
      id: file_id,
      domain: auth.domain,
      auth: auth.token,
    },
  });
}
export function exportToExcel(file_list) {
  let auth = updateAuth();
  return ajax({
    type: "POST",
    url: url_req,
    data: {
      run: "exporttoxxcel",
      files_for_export: file_list,
      domain: auth.domain,
      auth: auth.token,
      // eslint-disable-next-line
      lang: BX24.getLang(),
    },
  });
}
export function selectVisibleTableColumns(file_list) {
  let auth = updateAuth();
  return ajax({
    type: "POST",
    url: url_req,
    data: {
      run: "selectvisibletablecolumns",
      files_for_export: file_list,
      domain: auth.domain,
      auth: auth.token,
    },
  });
}
